import React from "react";
import Modal from "../../../../../components/Modal";
import BusinessForm from "../BusinessForm";
import useBusiness from "../../hooks/useBusiness";

interface ModalBusinessFormProps {
  isOpen: boolean;
  setClose: (modalState: boolean) => void;
  useCustomHook: ReturnType<typeof useBusiness>;
}

const ModalBusinessForm = ({
  isOpen, setClose, useCustomHook,
}: ModalBusinessFormProps) => {
  const { editValue } = useCustomHook;
  return (
    <Modal
      isOpen={isOpen}
      setOpen={setClose}
      title={`${editValue ? "Edit data" : "Tambah data"} - master business`}
      body={
        <BusinessForm useCustomHook={useCustomHook} onClose={() => setClose(false)} />
      }
    />
  );
};

export default ModalBusinessForm;
